@if (loading) {
<div class="loading">
    <mat-spinner diameter="50"></mat-spinner>
</div>
}
<router-outlet />